const my = {
  rule: 'Peraturan',
  Referral: 'Rujukan',
  Total_Earnings: 'jumlah diperolehi',
  Top_Referrer: 'Pengganti Permulaan',
  share: 'KONGSI',
  Starter_Referrer: 'Pengganti Permulaan',
  refer_desc:
    'Selepas pengguna baru membuat pesanan dan membayar, sistem akan memberikan ganjaran kepada pengganti seperti berikut:',
  points: 'mata',
  cash_voucher: 'baucar tunai',
  international: 'antarabangsa',
  next_day_delivery: 'Next Day Delivery',
  n_user: '{num1}orang',
  your_referral_code: 'Kod rujukan anda',
  already_top_referral:
    'Anda telah menjadi "Penaja Teratas" Setiap pengguna baru yang dijemput akan menerima ganjaran di atas',
  already_top_referral_text:
    'Setiap pengguna baru yang dijemput akan menerima ganjaran di atas',
  zai_add_new_user_n:
    ' Jemput {num1} pengguna baru untuk dinaik taraf ke "Penaja Teratas"',
  open_lock_five_new_user: 'Buka kunci pengguna baru ke-5',
  Invitation_record: 'Rekod jemputan',

  // Halaman pendaftaran
  register_title: 'Daftar',
  phone: 'Nombor Telefon',
  phone_placeholder: 'Sila masukkan nombor telefon',
  phone_required: 'Nombor telefon diperlukan',
  phone_length: 'Nombor telefon tidak boleh melebihi 13 aksara',
  password: 'Kata Laluan',
  password_placeholder: 'Sila masukkan kata laluan',
  password_required: 'Kata laluan diperlukan',
  verification_code: 'Kod Pengesahan',
  verification_code_placeholder: 'Sila masukkan kod pengesahan',
  verification_code_required: 'Kod pengesahan diperlukan',
  verification_code_format: 'Mesti nombor, maksimum 6 aksara',
  send_code: 'Dapatkan Kod',
  resend_code: 'Hantar Semula',
  privacy_agreement: 'Saya telah membaca dan bersetuju dengan Dasar Privasi',
  please_check_privacy: 'Sila bersetuju dengan Dasar Privasi',
  download_app: 'Muat Turun Aplikasi J&T Malaysia',
  name: 'Nama',
  name_placeholder: 'Sila masukkan nama',
  name_length: 'Nama tidak boleh melebihi 50 aksara',
  name_invalid_char: 'Nama mengandungi aksara tidak sah',
  id_number: 'ID / Pasport / SSM',
  id_number_placeholder: 'Sila masukkan ID / Pasport / SSM',
  id_number_required: 'ID / Pasport / SSM diperlukan',
  id_number_format: 'Mesti nombor, maksimum 12 aksara',
  email: 'E-mel',
  email_placeholder: 'Sila masukkan e-mel',
  email_required: 'E-mel diperlukan',
  email_format: 'Format e-mel tidak sah',
  referral_code: 'Kod Rujukan',
  referral_code_placeholder: 'Kod Rujukan',
  postcode: 'Poskod',
  postcode_placeholder: 'Sila masukkan poskod',
  postcode_format: 'Poskod mesti 5 digit',
  postcode_not_found: 'Poskod tidak dijumpai',
  city: 'Bandar',
  city_placeholder: 'Bandar akan diisi automatik oleh poskod',
  city_required: 'Bandar diperlukan, sila masukkan poskod yang sah',
  address: 'Alamat',
  address_placeholder: 'Sila masukkan alamat',
  address_length: 'Alamat tidak boleh melebihi 250 aksara',
  address_invalid_char: 'Alamat mengandungi aksara tidak sah',
  complete_register: 'Lengkapkan Pendaftaran',
  register_success: 'Pendaftaran Berjaya',
  register_success_desc: 'Tahniah atas pendaftaran anda yang berjaya!',
  back_to_home: 'Kembali ke Laman Utama',
  account_info: 'Maklumat Akaun',
  identity_info: 'Maklumat Identiti',
  contact_address: 'Alamat Perhubungan',
  privacy_prefix: 'Saya telah membaca dan bersetuju dengan J&T Express',
  privacy_terms: 'Terma dan Dasar Privasi',
  already_have_account: 'Sudah mempunyai akaun?',
  download_jt_malaysia_app: 'Log masuk sekarang',
  area_placeholder: 'Sila pilih / masukkan bandar',
  verification_code_error: 'Kod pengesahan tidak betul',
  register_success_title: 'Tahniah, pendaftaran berjaya!',
  register_success_detail:
    'Akaun anda telah diaktifkan. Muat turun App sekarang untuk membuka lebih banyak<br />perkhidmatan logistik & ganjaran eksklusif',
  download_jt_malaysia_app_now: 'Log masuk sekarang',
  register_download_desc:
    'Selepas memuat turun App, log masuk dengan nombor telefon yang didaftarkan<br />untuk menggunakan semua perkhidmatan dan menuntut ganjaran',
  register_footer_text:
    'J&T Malaysia · Menyediakan perkhidmatan logistik yang mudah'
}

export default my
